.price {
  font-size: var(--m-fs-md);
  font-weight: var(--m-fw-bold);
  &[data-owned='true'] {
    @apply --mx-bg(var(--m-color-success-wash));
    @apply --mx-fg(var(--m-color-success-ink));
  }
}
